import gql from 'graphql-tag';

export default gql`
  mutation Gettoken($email: String!, $password: String!) {
    getSessionToken(email: $email, password: $password) {
      token
      enabledStats
      user {
        id
        name
        type
        theater {
          id
          plan
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/GetToken.js